<template>
  <span v-if="user.information">
    <span v-if="!showMultiple && meetingEnabled">
       <b-button class="inlineBtn" variant="dark" @click="showJitsi">
               {{ $t("MEETINGS.COMPOSE") }}
            </b-button>
    </span>
    <span v-if="showMultiple && meetingEnabled">
      <b-dropdown
          variant="dark"
        >
          <template #button-content>{{ $t("MEETINGS.COMPOSE") }}</template>
          <b-dropdown-item href="#" v-if="jitsi_confidential_enabled" @click="showJitsiConfidentially"><img class="icon mr-2" src="/img/message_type/jitsi-secure-meeting.png" /> {{ $t("MESSAGES.TYPE.jitsi-secure-meeting") }}</b-dropdown-item>
          <b-dropdown-item href="#" v-if="jitsi_enabled"  @click="showJitsi"><img class="icon mr-2" src="/img/message_type/jitsi-meeting.png" /> {{ $t("MESSAGES.TYPE.jitsi-meeting") }}</b-dropdown-item>
          <b-dropdown-item href="#" v-if="nuiteq_enabled"  @click="showNuiteq"><img class="icon mr-2" src="/img/message_type/nuiteq-meeting.png" /> {{ $t("MESSAGES.TYPE.nuiteq-meeting") }}</b-dropdown-item>
        </b-dropdown>
    </span>
    <AddJitsiMeeting v-if="jitsi_enabled" :show="showJitsiMeeting" @changeShow="changeShowJitsiMeeting" @sentMeeting="sentMeeting"></AddJitsiMeeting>
    <AddJitsiConfidentiallyMeeting v-if="jitsi_confidential_enabled" :show="showJitsiConfidentiallyMeeting"  @changeShow="changeShowJitsiConfidentiallyMeeting" @sentMeeting="sentMeeting"></AddJitsiConfidentiallyMeeting>
    <AddNuiteqMeeting v-if="nuiteq_enabled" :show="showNuiteqMeeting"  @changeShow="changeShowNuiteqMeeting" @sentMeeting="sentMeeting"></AddNuiteqMeeting>
  </span>
</template>
<script>
import AddJitsiMeeting from "@/components/Compose/Meeting/JitsiMeeting";
import AddJitsiConfidentiallyMeeting from "@/components/Compose/Meeting/JitsiConfidentiallyMeeting";
import AddNuiteqMeeting from "@/components/Compose/Meeting/NuiteqMeeting";
export default {
  components: {
    AddNuiteqMeeting,
    AddJitsiMeeting,
    AddJitsiConfidentiallyMeeting
  },
  data() {
    return {
      showNuiteqMeeting: false,
      showJitsiMeeting: false,
      showJitsiConfidentiallyMeeting: false,
      nuiteq_enabled: false,
      teams_enabled: false,
      jitsi_enabled: false,
      jitsi_confidential_enabled: false,
    };
  },
  methods: {
    async checkEnabled(){
      let self = this;
      await this.$http
        .get(this.user.hostname + "/nuiteq/enabled")
        .then(function(result) {
          self.nuiteq_enabled = result.data;
        })
        .catch(function() {
          self.nuiteq_enabled = false;
        });
      await this.$http
        .get(this.user.hostname + "/jitsi/enabled")
        .then(function(result) {
          self.jitsi_enabled = result.data;
        })
        .catch(function() {
          self.jitsi_enabled = false;
        });      
      await this.$http
        .get(this.user.hostname + "/jitsi/confidentially/enabled")
        .then(function(result) {
          self.jitsi_confidential_enabled = result.data;
        })
        .catch(function() {
          self.jitsi_confidential_enabled = false;
        });     
    },
    changeShowNuiteqMeeting(val){
      this.showNuiteqMeeting = val;
    },
    changeShowJitsiMeeting(val){
      this.showJitsiMeeting = val;
    },
    changeShowJitsiConfidentiallyMeeting(val){
      this.showJitsiConfidentiallyMeeting = val;
    },
    showJitsi(){
      this.showJitsiMeeting = true;
    },
    showJitsiConfidentially(){
      this.showJitsiConfidentiallyMeeting = true;
    },
    showNuiteq(){
      this.showNuiteqMeeting = true;
    },
    sentMeeting() {
      this.showNuiteqMeeting = false;
      this.showJitsiMeeting = false;
      this.showJitsiConfidentiallyMeeting = false;
      this.$emit("sentMeeting");
    }
  },
  computed: {
    meetingEnabled(){
      return this.jitsi_confidential_enabled || this.jitsi_enabled || this.nuiteq_enabled;
    },
    showMultiple() {
      return true;
    },
    composeText() {
      return this.$t('MESSAGES.COMPOSE') + " - SEFOS";
    }
  },
  mounted() {
    this.checkEnabled();
  },
};
</script>
